const enMessages = {
  '': '',
  ' ': ' ',

  // A

  'Afternoon Hour': 'Afternoon Hour',
  'Academic Year': 'Academic Year',
  'Allocate Cost': 'Allocate Cost',
  "Appraiser's Statement": "Appraiser's Statement",
  "Appraisee's Statement": "Appraisee's Statement",
  "Appraisee's Comment": "Appraisee's Comment",
  'Association Degree': 'Association Degree',
  Accepted: 'Accepted',
  'Annual Review': 'Annual Review',
  'Appraiser Comment': 'Appraiser Comment',
  "Appraisal's Statement": "Appraisal's Statement",
  'Appraisee Final Statement': 'Appraisee Final Statement',
  "APPRAISEES's COMMENTS": "APPRAISEES's COMMENTS",
  'Accomplished less than 50% of the expectation': 'Accomplished less than 50% of the expectation',
  'Accomplished 50% or more of the expectation': 'Accomplished 50% or more of the expectation',
  'Accomplished just over expectations by less than 50%': 'Accomplished just over expectations by less than 50%',
  'Tardiness or Attendance score': 'Tardiness or Attendance score',
  'Attendance Rating': 'Attendance Rating',
  'Tardiness or Attendance Result (Score)': 'Tardiness or Attendance Result (Score)',
  'Attendance Result (Score)': 'Attendance Result (Score)',
  'Appraiser Final Statement': 'Appraiser Final Statement',
  'Appraisal Date & Statement': 'Appraisal Date & Statement',
  'Appraisal Date': 'Appraisal Date',
  'Address in Khmer': 'Address in Khmer',
  'Assign To Name': 'Assign To Name',
  'Assign To Name 2': 'Assign To Name 2',
  'Afternoon Break (Minute)': 'Afternoon Break (Minute)',
  'Attendance Missing Hour': 'Attendance Missing Hour',
  Agreement: 'Agreement',
  'Absentee Employee No': 'Absentee Employee No',
  'Afternoon break no of minute': 'Afternoon break no of minute',
  Attendance: 'Attendance',
  'Afternoon Starting Time': 'Afternoon Starting Time',
  'Afternoon Ending Time': 'Afternoon Ending Time',
  'Attendance History Record': 'Attendance History Record',
  'Attendance Missing Type': 'Attendance Missing Type',
  'Attendance Missing Period': 'Attendance Missing Period',
  Approver: 'Approver',
  'Actual In/Out Time': 'Actual In/Out Time',
  'Approval Workflow Activities': 'Approval Workflow Activities',
  'Attachment Files': 'Attachment Files',
  Address: 'Address',
  'Appraisal Request Form': 'Appraisal Request Form',
  'Performance Appraisal Request': 'KPI Setting and Performance Appraisal',
  'Appraisal Rating': 'Appraisal Rating',
  'Appraisal Results': 'Appraisal Results',
  'Appraisal Type': 'Appraisal Type',
  'Appraisal Summary Analysis': 'Appraisal Summary Analysis',
  'Appraisal Detail': 'Appraisal Detail',
  'Attached a file on': 'Attached a file on',
  'Assessment Training Training Plan Need': 'Assessment Training Training Plan Need',
  'Appraisal Comment': 'Appraisal Comment',
  Approved: 'Approved',
  'Appraiser Rating Option': 'Appraiser Rating Option',
  "Appraiser's Comments": "Appraiser's Comments",
  'Appraiser Score': 'Appraiser Score',
  'Actual Achievement': 'Actual Achievement',
  'Appraiser KPI Score': 'Appraiser KPI Score',
  'Appraiser Behavior and Skill Score': 'Appraiser Behavior and Skill Score',
  'Assessement Of Training': 'Assessement Of Training',
  Agree: 'Agree',
  Attachment: 'Attachment',
  'Achieving Results': 'Achieving Results',
  'Analytical Thinking': 'Analytical Thinking',
  Add: 'Add',
  'Assessment Of Training Survey': 'Assessment Of Training Survey',
  Afternoon: 'Afternoon',
  Absence: 'Absence',
  'Annual Leave': 'Annual Leave',
  A5: 'A5',
  A4: 'A4',
  'Assign To User': 'Assign To User',
  'Assign To User 2': 'Assign To User 2',
  All: 'All',
  'Approval Document': 'Approval Document',
  'Annual Leave Entitlement Balance': 'Annual Leave Entitlement Balance',
  Announcements: 'Announcements',
  'Activity Status': 'Activity Status',
  'Activity Type': 'Activity Type',
  Aborted: 'Aborted',
  'Activity Date': 'Activity Date',
  Accept: 'Accept',
  'Activity Task Description': 'Activity Task Description',
  'Address (If any)': 'Address (If any)',
  'Afternoon (In)': 'Afternoon (In)',
  'Afternoon (Out)': 'Afternoon (Out)',
  'Activity Tasks': 'Activity Tasks',
  'Activity Time': 'Activity Time',
  'Activty Type': 'Activty Type',
  'Are there any policies, regulations or other contexts making you difficult to implement your tasks?':
    'Are there any policies, regulations or other contexts making you difficult to implement your tasks?',
  'Attendance Assessment': 'Attendance Assessment',
  'Attendance Score Result': 'Attendance Score Result',
  Approve: 'Approve',
  'Acknowledge Date': 'Acknowledge Date',
  'Approval Community': 'Approval Community',
  'Approve By': 'Approve By',
  'Assign Team': 'Assign Team',
  'Appraisal Period From Date': 'Appraisal Period From Date',
  'Appraisal Period to Date': 'Appraisal Period to Date',

  // B

  'Bank Account Name': 'Bank Account Name',
  'Bachelor Degree': 'Bachelor Degree',
  Broken: 'Broken',
  'Behavior and Skill Score': 'Behavior and Skill Score',
  'Business or Departmental Functions/Projects/Internal Process': 'Business or Departmental Functions/Projects/Internal Process',
  Building: 'Building',
  'Bank Name': 'Bank Name',
  'Basic Salary': 'Basic Salary',
  'Bank Account Number': 'Bank Account Number',
  'Birth Address': 'Birth Address',
  'Basic Salary Option': 'Basic Salary Option',
  'Birth District': 'Birth District',
  'Birth Province': 'Birth Province',
  'Birth Country Code': 'Birth Country Code',
  Break: 'Break',
  'Break Starting Time': 'Break Starting Time',
  'Break Ending Time': 'Break Ending Time',
  'Branch Code': 'Branch Code',
  'Behavior Assessment': 'Behavior Assessment',
  Back: 'Back',
  'Behavior Description': 'Behavior Description',
  'Business Unit Code': 'Business Unit Code',
  'Brief Summary of the course content': 'Brief Summary of the course content',
  'Block Leave': 'Block Leave',
  'Brief Description': 'Brief Description',
  'Brief Description (Name of External Partner)': 'Brief Description (Name of External Partner)',
  'Brief Description (Name of Files and Password)': 'Brief Description (Name of Files and Password)',
  'Brief Description (Name of Internal Partner)': 'Brief Description (Name of Internal Partner)',
  'Break Time': 'Break Time',
  'Branch Changed': 'Branch Changed',

  // C

  Campus: 'Campus',
  Cancelled: 'Cancelled',
  Computer: 'Computer',
  'Change of Working Hour': 'Change of Working Hour',
  'Condition Change': 'Condition Change',
  'Change of Bank Account': 'Change of Bank Account',
  'Change of National ID Card': 'Change of National ID Card',
  'Company Phone Number': 'Company Phone Number',
  'Campus Changed': 'Campus Changed',
  Confirmation: 'Confirmation',
  'Change In Job Role': 'Change In Job Role',
  Child: 'Child',
  'Change Position': 'Change Position',
  'Change Lanyard': 'Change Lanyard',
  'Change Department': 'Change Department',
  'Confirming Objectives Agreed Upon at the Beginning of the Period': 'Confirming Objectives Agreed Upon at the Beginning of the Period',
  'Confirming Objectives Agreed at Start of the Beginning Period': 'Confirming Objectives Agreed at Start of the Beginning Period',
  'Change of Marital Status': 'Change of Marital Status',
  'Contact Number 2': 'Contact Number 2',
  'Change of Name': 'Change of Name',
  'Contact Number': 'Contact Number',
  'Change of Emergency Contact Detail': 'Change of Emergency Contact Detail',
  'Change of Phone Number': 'Change of Phone Number',
  'Change of Address': 'Change of Address',
  'Change of Date of Birth': 'Change of Date of Birth',
  'Confirmed and Unsuccessful Probation Form': 'Probation Confirmation',
  'Confirmed and Unsuccessful Probation': 'Probation Confirmation',
  'Customer Service': 'Customer Service',
  'Completed Name': 'Completed Name',
  'Completed By': 'Completed By',
  'Committed Start Date': 'Committed Start Date',
  'Committed End Date': 'Committed End Date',
  'Company  Phone No': 'Company  Phone No',
  'Current Address': 'Current Address',
  'Contract Information': 'Contract Information',
  'Contract Made Issue Date': 'Contract Made Issue Date',
  'Clock Time Card No': 'Clock Time Card No',
  'Checklist Template Code': 'Checklist Template Code',
  'Cessation Tasks': 'Cessation Tasks',
  'Course Book': 'Course Book',
  'Card No': 'Card No',
  'Commnuication and Address': 'Commnuication and Address',
  'Change Dayoff Request Form': 'Change Dayoff Request Form',
  'Change Timesheets Request Form': 'Change Timesheets Request Form',
  Career: 'Career',
  'Career Change Request Form': 'Career Change Request Form',
  Condition: 'Condition',
  'Change Day Off Details': 'Change Day Off Details',
  'Changing Reason Remark': 'Changing Reason Remark',
  'Contract Type': 'Contract Type',
  'Change Dayoff Request': 'Change Dayoff Request',
  'Click here to Files!': 'Click here to Files!',
  Closed: 'Closed',
  Category: 'Category',
  Communication: 'Communication',
  'Course Date': 'Course Date',
  'Course Offered by': 'Course Offered by',
  'Course Information': 'Course Information',
  'Compassionate Leave': 'Compassionate Leave',
  'Change Day-Off Leave': 'Change Day-Off Leave',
  'Checked Out': 'Checked Out',
  'Checked In': 'Checked In',
  Checked: 'Checked',
  Close: 'Close',
  Completed: 'Completed',
  'Checking Date': 'Checking Date',
  'Checking Time': 'Checking Time',
  'Completed Date': 'Completed Date',
  'Completed Time': 'Completed Time',
  'Checking Status': 'Checking Status',
  'Contact Details (Phone Number or Email)': 'Contact Details (Phone Number or Email)',
  Cancalled: 'Cancalled',
  Carrer: 'Carrer',
  Cancel: 'Cancel',
  'Checked Out Time': 'Checked Out Time',
  'Checked In Time': 'Checked In Time',
  'Checked In Time (Break)': 'Checked In Time (Break)',
  'Checked Out Time (Break)': 'Checked Out Time (Break)',
  'Change Permanent Address Information': 'Change Permanent Address Information',
  'Change Birth Address Information': 'Change Birth Address Information',
  'Change Contact & Emergency Contact': 'Change Contact & Emergency Contact',
  'Change Personal Information': 'Change Personal Information',
  'Change Current Address Information': 'Change Current Address Information',
  Conclusion: 'Conclusion',
  'Change Timesheet Request': 'Change Timesheet Request',
  Comments: 'Comments',
  'Committed Date': 'Committed Date',
  'Contract Ending Date': 'Contract Ending Date',
  'Contract Starting Date': 'Contract Starting Date',
  'Current Basic Salary': 'Current Basic Salary',
  'Change Shift Request Form': 'Change Shift Request Form',
  'Classroom + Online': 'Classroom + Online',
  'Campus Code': 'Campus Code',
  'Committee Approval': 'Committee Approval',
  'Check By': 'Check By',
  Custom: 'Custom',
  'Course Location': 'Course Location',

  // D

  'Date of Missing': 'Date of Missing',
  'Do you want to send notify to your successor?': 'Do you want to send notify to your successor?',
  'Department Transferred': 'Department Transferred',
  Demotion: 'Demotion',
  Demoted: 'Demoted',
  'Delegate To Name': 'Delegate To Name',
  'Delegate To': 'Delegate To',
  Dissatified: 'Dissatified',
  Division: 'Division',
  'Division 1': 'Division',
  Delete: 'Delete',
  'DISCIPLINARY-TERMINATION': 'DISCIPLINARY-TERMINATION',
  'Do you need the MJQE sponsor your PhD, Master, Bachelor?': 'Do you need the MJQE sponsor your PhD, Master, Bachelor?',
  'During Working Hour': 'During Working Hour',
  Description: 'Description',
  Department: 'Department',
  'Daily Clock Time Report': 'Daily Clock Time Report',
  'Daily Timesheet Matching Report': 'Daily Timesheet Matching Report',
  'Daily Summary Working Hour Report': 'Daily Summary Working Hour Report',
  'Daily Attendance KPI Report': 'Daily Attendance KPI Report',
  'Daily Overtime Summary Report': 'Daily Overtime Summary Report',
  'Disciplinary Action Request': 'Disciplinary Action Request',
  'Disciplinary Record': 'Disciplinary Record',
  Dashboards: 'Dashboards',
  Default: 'Default',
  'Date Of Birth': 'Date Of Birth',
  District: 'District',
  Date: 'Date',
  'Division Code': 'Division Code',
  'Department Code': 'Department Code',
  'Do you want to delete file?': 'Do you want to delete file?',
  Disposed: 'Disposed',
  Draft: 'Draft',
  'Drop Files': 'Drop Files',
  Disagree: 'Disagree',
  'Document Date': 'Document Date',
  'Day-Off': 'Day-Off',
  'Duties in Job Description and Other Tasks': 'Duties in Job Description and Other Tasks',
  'Document No': 'Document No',
  'Document Type': 'Document Type',
  'Daily Attendance Report On': 'Daily Attendance Report On',
  Documents: 'Documents',
  'Due Date': 'Due Date',
  'Date of the Incident': 'Date of the Incident',
  'Description of the Incident': 'Description of the Incident',
  Dispose: 'Dispose',
  'Date of Birth': 'Date of Birth',
  'Deduction Amount': 'Deduction Amount',
  'Description of Chronological Events': 'Description of Chronological Events',
  'Describe what you like most during your employment': 'Describe what you like most during your employment',
  'Describe what you like least during your employment': 'Describe what you like least during your employment',
  'Delegate Approval': 'Delegate Approval',
  Descriptions: 'Descriptions',
  'Disciplinary Details': 'Disciplinary Details',
  'Disciplinary Action Code': 'Disciplinary Action Code',
  'Day Off Entitlement Balance': 'Day Off Entitlement Balance',
  'Document Status': 'Document Status',
  DEFAULT: 'DEFAULT',
  Delegate: 'Delegate',
  Day: 'Day',
  'Degree Sponsorship Request Form': 'Degree Sponsorship Request Form',

  // E

  'Evening Hour': 'Evening Hour',
  'Employee Feedback Survey': 'Employee Feedback Survey',
  'Expired Date': 'Expired Date',
  'Employee Engagement Survey': 'Employee Engagement Survey',
  'Engagement Survey Open! Please complete the company engagement survey between':
    'Engagement Survey Open! Please complete the company engagement survey between',
  'Engagement Survey': 'Engagement Survey',
  External: 'External',
  'End Of Probation Details': 'End Of Probation Details',
  'Employee’s Comment': 'Employee’s Comment',
  'Event Date': 'Event Date',
  'Employee Training Registration': 'Employee Training Registration',
  "Employee's Department": "Employee's Department",
  'EMPLOYEE DISCIPLINARY': 'EMPLOYEE DISCIPLINARY',
  'EMPLOYEE DISCIPLINARY-2': 'EMPLOYEE DISCIPLINARY-2',
  'Employee Type': 'Employee Type',
  'Employee Category': 'Employee Category',
  'Employee Level': 'Employee Level',
  'Employee Department Username': 'Employee Department Username',
  'Estimated End Date': 'Estimated End Date',
  'Emphasize the 3 most important roles & responsibilities of your position': 'Emphasize the 3 most important roles & responsibilities of your position',
  'Evening Break (Minute)': 'Evening Break (Minute)',
  'Evening break no of minute': 'Evening break no of minute',
  'Evening Starting Time': 'Evening Starting Time',
  'Evening Ending Time': 'Evening Ending Time',
  'EMPLOYEE INCIDENT TO ER': 'EMPLOYEE INCIDENT TO ER',
  'End Of Contract Notice Day': 'End Of Contract Notice Day',
  'End Of Contract Notice Pay Type': 'End Of Contract Notice Pay Type',
  'Employee Name': 'Employee Name',
  'End Probation Request Form': 'End Probation Request Form',
  'Employment Certificate Request Form': 'Employment Certificate Request Form',
  'External Training Request Form': 'External Training Request Form',
  'Employee Details': 'Employee Details',
  'Ending Time': 'Ending Time',
  'Emergency Contact Phone No': 'Emergency Contact Phone No',
  'Emergency Contact Name': 'Emergency Contact Name',
  Email: 'Email',
  'Employee ID Number': 'Employee ID Number',
  'Employee No': 'Employee No',
  'Employee ID': 'Employee ID',
  'Ending Date': 'Ending Date',
  'Emergency Phone Number': 'Emergency Phone Number',
  'Extension No': 'Extension No',
  'Employee Information': 'Employee Information',
  'Employee Appraisal Request': 'KPI Setting and Performance Appraisal',
  'Exceed expectation': 'Exceed expectation',
  'Exceeds Expectation': 'Exceeds Expectation',
  'Employee Training Questionnaire': 'Employee Training Questionnaire',
  'End Date': 'End Date',
  'External Training Request': 'External Training Request',
  'Employee Scholarship Request': 'Employee Scholarship Request',
  'End Probation Request': 'End Probation Request',
  'Employee Career Change Request': 'Employee Career Change Request',
  'Employment Certificate Request': 'Employment Certificate Request',
  'Employee Disciplinary Form': 'Employee Disciplinary Form',
  'Employee Handover Files': 'Employee Handover Files',
  'External Relationship/Partnership Contact': 'External Relationship/Partnership Contact',
  'Effective Date': 'Effective Date',
  'Employee Exit Clearance Form': 'Employee Exit Clearance',
  'Employee Exit Clearance': 'Employee Exit Clearance',
  'Employee Visas': 'Employee Visas',
  'Employee Worksheets': 'Employee Worksheets',
  'Employee Contracts': 'Employee Contracts',
  'Employee Work Permits': 'Employee Work Permits',
  'Employee Work Books': 'Employee Work Books',
  'Employee Contracts Expire In 60 Days': 'Employee Contracts Expire In 60 Days',
  'Employee Visa Expire In 30 Days': 'Employee Visa Expire In 30 Days',
  'Employee Work Permits Expire In 30 Days': 'Employee Work Permits Expire In 30 Days',
  'Employee Work Books Expire In 30 Days': 'Employee Work Books Expire In 30 Days',
  'Employee Cessation Form': 'Employee Cessation Form',
  'Employee Payroll Histories': 'Employee Payroll Histories',
  'Employee Incident Request': 'Incident Report',
  'Evening (In)': 'Evening (In)',
  'Evening (Out)': 'Evening (Out)',
  Evening: 'Evening',
  Employee: 'Employee',
  'Employee Satisfaction Form': 'Employee Satisfaction Form',
  'Employee Exit Interview': 'Employee Exit Interview',
  'Employee Disciplinary Request': 'Disciplinary Action Request',
  'Employee Leave Entitlement Record': 'Employee Leave Entitlement Record',
  'Expire Date': 'Expire Date',
  'Employee Training Request': 'Employee Training Request',
  'External Training Report': 'External Training Report',
  'External Scholarship Request': 'External Scholarship Request',

  // F

  'Full Time': 'Full Time',
  'Final Grade': 'Final Grade',
  'Final Score': 'Final Score',
  'Financial/Business Performance': 'Financial/Business Performance',
  'Finance Department': 'Finance Department',
  'First Name in Latin': 'First Name in Latin',
  'First Name in Khmer': 'First Name in Khmer',
  'Finance Department Username': 'Finance Department Username',
  'For Human Resources Only': 'For Human Resources Only',
  Files: 'Files',
  'First Priority Skills': 'First Priority Skills',
  'First Priority Remark': 'First Priority Remark',
  'First Name': 'First Name',
  'First Name 2': 'First Name 2',
  'From Worksheet Code': 'From Worksheet Code',
  Functions: 'Functions',
  From: 'From',
  "FINAL REVIEW: Appraiser's Comments & Overall Performance Results": "FINAL REVIEW: Appraiser's Comments & Overall Performance Results",
  'Final Appraisal Score': 'Final Appraisal Score',
  'Final Appraisal Grade': 'Final Appraisal Grade',
  Flexibility: 'Flexibility',
  'File Description': 'File Description',
  Female: 'Female',
  'From Time': 'From Time',
  'Full Day': 'Full Day',
  'Final Written Warning': 'Final Written Warning',
  'Final Written Warning with Suspended Working': 'Final Written Warning with Suspended Working',
  Friday: 'Friday',

  // G
  General: 'General',
  Gender: 'Gender',
  'Gross Pay': 'Gross Pay',
  'Gross Pay Amount': 'Gross Pay Amount',
  'Gross Pay Amount (2nd)': 'Gross Pay Amount (2nd)',
  Group: 'Group',

  // H

  'Half-Full Time': 'Half-Full Time',
  'Human Resources Department': 'Human Resources Department',
  'Handover Committees': 'Handover Committees',
  'HR Department Username': 'HR Department Username',
  'Hard Documents such as Binder/Box File/Key Documents/Referent Materials (Attached if possible)':
    'Hard Documents such as Binder/Box File/Key Documents/Referent Materials (Attached if possible)',
  'HOD Status': 'HOD Status',
  "HoD's Status": "HoD's Status",
  "HoD's Comment": "HoD's Comment",
  'HR Conclusion No': 'HR Conclusion No',
  Home: 'Home',
  'Hard Skills Assessment': 'Hard Skills Assessment',
  High: 'High',
  Hard: 'Hard',
  'How will this training benefit you and the company?': 'How will this training benefit you and the company?',
  'Hr Induction Assessment Test': 'Hr Induction Assessment Test',
  'Hr Induction Assessment Test Employee': 'Hr Induction Assessment Test Employee',
  'HR Induction Assessment (E)': 'HR Induction Assessment (E)',
  'HR Induction Assessment (C)': 'HR Induction Assessment (C)',
  'HR Induction Assessment Test (E)': 'HR Induction Assessment Test (E)',
  'HR Induction Assessment Test (C)': 'HR Induction Assessment Test (C)',

  // I

  'Input Weightage % (KPI)': 'Input Weightage % (KPI)',
  Initialed: 'Initialed',
  'In House Staff Leave': 'In House Staff Leave',
  'In House Leave': 'In House Leave',
  Introduction: 'Introduction',
  'INTRODUCTION OF TERMINATION': 'INTRODUCTION OF TERMINATION',
  Internal: 'Internal',
  Individual: 'Individual',
  'In Working Hour': 'In Working Hour',
  'ID Card Printing Request': 'ID Card Printing Request',
  'Information Detail': 'Information Detail',
  'I accept receive appraisal': 'I accept receive appraisal',
  'I was given feedback and coaching throughout my evaluation': 'I was given feedback and coaching throughout my evaluation',
  'Information Technology Department': 'Information Technology Department',
  'Interview Status': 'Interview Status',
  'Information Khmer': 'Information Khmer',
  Information: 'Information',
  'IT Department Username': 'IT Department Username',
  'International Travel': 'International Travel',
  'Incident Record': 'Incident Record',
  'Incident Report': 'Incident Report',
  'ID Card No': 'ID Card No',
  'Incident Details': 'Incident Details',
  'Information of Staff Family Requesting for Scholarship': 'Information of Staff Family Requesting for Scholarship',
  'Introduction Of Termination': 'Introduction Of Termination',
  'Incident Result': 'Incident Result',
  'Id Card No': 'Id Card No',
  'Internal Training Request Form': 'Internal Training Request Form',
  'Initial By': 'Initial By',
  'Incident End Date': 'Incident End Date',
  'Incident Start Date': 'Incident Start Date',
  'Information The Person You Evaluate': 'Information The Person You Evaluate',

  // J

  'Job Abandonment': 'Job Abandonment',
  'Job Title': 'Job Title',
  'Job Off-boarding Checklist': 'Job Off-boarding Checklist',
  'Job On-boarding Checklist': 'Job On-boarding Checklist',
  'Job Requisition Request Form': 'Job Requisition Request Form',
  'Join Date': 'Join Date',
  'Job Information': 'Job Information',
  'Job Education': 'Job Education',
  'Job Requisition Details': 'Job Requisition Details',
  'Job Description': 'Job Description',
  'Job Education Qualification': 'Job Education Qualification',
  'Job Requisition': 'Job Requisition',
  'Job Onboarding Task': 'Job Onboarding Task',
  'Joined Date': 'Joined Date',
  'Job Announcement Doc No': 'Job Announcement Doc No',
  'Job Handover Request': 'Job Handover Form',
  'Job Handover Request Form': 'Job Handover Form',
  'Job Handover Form': 'Job Handover Form',

  // K
  'Key Performance Indicator (KPI)': 'Key Performance Indicator (KPI)',
  KPI: 'KPI',
  'Knowledge, Skill, And Experience Qualification': 'Knowledge, Skill, And Experience Qualification',
  'Khmer Name': 'Khmer Name',
  'KPI Score': 'KPI Score',
  'Key Internal Relationship/Partnership Contact': 'Key Internal Relationship/Partnership Contact',

  // L

  'Line manger ID': 'Line manger ID',
  'Line manger ID 2': 'Line manger ID 2',
  'Line Manager Name 2': 'Line Manager Name 2',
  'Learning Channel': 'Learning Channel',
  'Learning Type': 'Learning Type',
  'Local Training': 'Local Training',
  Lost: 'Lost',
  'Line Code': 'Line Code',
  'Line Manager': 'Line Manager',
  'Line Manager (2)': 'Line Manager (2)',
  'Line Manager Name (2)': 'Line Manager Name (2)',
  'Last Working Day': 'Last Working Day',
  'Line Manager ID': 'Line Manager ID',
  'Line Manager ID (2)': 'Line Manager ID (2)',
  'Last Name in Latin': 'Last Name in Latin',
  'Last Name in Khmer': 'Last Name in Khmer',
  'Library Department Username': 'Library Department Username',
  'Length Of Education': 'Length Of Education',
  'Level/Grade': 'Level/Grade',
  Local: 'Local',
  'Local Travel': 'Local Travel',
  'Leave For': 'Leave For',
  'Leave Option': 'Leave Option',
  'Last Change Career Date': 'Last Change Career Date',
  'Line Manager No': 'Line Manager No',
  'Last Name 2': 'Last Name 2',
  'Last Name': 'Last Name',
  'Leave Request Form': 'Leave Request Form',
  'Leave Details': 'Leave Details',
  'Line Manager Name': 'Line Manager Name',
  'Level Of Training Priority': 'Level Of Training Priority',
  Low: 'Low',
  Leadership: 'Leadership',
  Location: 'Location',
  Leave: 'Leave',
  'Long Sick Leave': 'Long Sick Leave',
  'Leave Time': 'Leave Time',
  'Last Working Date': 'Last Working Date',
  'Last working Date': 'Last working Date',
  'Loan Amount': 'Loan Amount',
  'Loan Settlement Amount': 'Loan Settlement Amount',
  'Leave Before or After long Holiday': 'Leave Before or After long Holiday',

  // M

  'My appraiser has discussed my developmental plans with me': 'My appraiser has discussed my developmental plans with me',
  'Morning Hour': 'Morning Hour',
  'Mail Content': 'Mail Content',
  'Master Degree': 'Master Degree',
  'Mid-Year Annual Review': 'Mid-Year Annual Review',
  Married: 'Married',
  'My appraiser and I conducted review': 'My appraiser and I conducted review',
  'Mengly J. Quach Library': 'Mengly J. Quach Library',
  Major: 'Major',
  'Morning Break (Minute)': 'Morning Break (Minute)',
  'Morning break no of minute': 'Morning break no of minute',
  'Morning Starting Time': 'Morning Starting Time',
  'Morning Ending Time': 'Morning Ending Time',
  'Monthly Attendance KPI Report': 'Monthly Attendance KPI Report',
  'Marital Status': 'Marital Status',
  'Measures Metrics': 'Measures Metrics',
  'Meet expectation': 'Meet expectation',
  Management: 'Management',
  Medium: 'Medium',
  Male: 'Male',
  Morning: 'Morning',
  'Marriage Leave': 'Marriage Leave',
  'Maternity Leave': 'Maternity Leave',
  'Mission Leave': 'Mission Leave',
  'My Approval Document': 'My Approval Document',
  'My Task Activity': 'My Task Activity',
  'My Request Approval': 'My Request Approval',
  'Morning (In)': 'Morning (In)',
  'Morning (Out)': 'Morning (Out)',
  'Misconduct Description': 'Misconduct Description',
  Monday: 'Monday',

  // N

  'Night Hour': 'Night Hour',
  'Night Shift': 'Night Shift',
  'Night Break': 'Night Break',
  'National ID Card Issue Date': 'National ID Card Issue Date',
  'National ID Card Expired Date': 'National ID Card Expired Date',
  'New Personal Information': 'New Personal Information',
  No: 'No',
  'New Employee Announcement': 'New Employee Announcement',
  'New Employee': 'New Employee',
  'New Phone Number': 'New Phone Number',
  'Name in Khmer': 'Name in Khmer',
  'Name in Latin': 'Name in Latin',
  Nationality: 'Nationality',
  'ID Card Number': 'ID Card Number',
  'National ID Card': 'National ID Card',
  'National ID Issue Date': 'National ID Issue Date',
  'NSSF No': 'NSSF No',
  'Notice Day or Month': 'Notice Day or Month',
  'Notice Day': 'Notice Day',
  'No Of Day': 'No Of Day',
  'No Of Hour': 'No Of Hour',
  Normal: 'Normal',
  'No. of Days': 'No. of Days',
  'No. of Hours': 'No. of Hours',
  'No. of Minutes': 'No. of Minutes',
  'No. Of Working Hours': 'No. Of Working Hours',
  'No. Of Break Hours': 'No. Of Break Hours',
  Name: 'Name',
  'Nationality Code': 'Nationality Code',
  'Net Pay': 'Net Pay',
  'No, cancel!': 'No, cancel!',
  New: 'New',
  'Nothing has been done': 'Nothing has been done',
  'Number of Days': 'Number of Days',
  'Name of Course': 'Name of Course',
  'No. Of Day(s)': 'No. Of Day(s)',
  'Name of Successor': 'Name of Successor',
  'New Job Onboarding Checklist': 'New Job Onboarding Checklist',
  Night: 'Night',
  'No. Of Working Day': 'No. Of Working Day',
  'No. Of Working Time': 'No. Of Working Time',
  'No. Of Late Day': 'No. Of Late Day',
  'No. Of Leave Day': 'No. Of Leave Day',
  'Night (In)': 'Night (In)',
  'Night (Out)': 'Night (Out)',
  'No. Of Evening Working Hours': 'No. Of Evening Working Hours',
  'Notice Option': 'Notice Option',
  'Notice Date': 'Notice Date',
  'No of day': 'No of day',
  'Net Pay Amount': 'Net Pay Amount',
  'No of Day': 'No of Day',

  // O

  'Old Personal Information': 'Old Personal Information',
  Outsource: 'Outsource',
  'Oversea Training': 'Oversea Training',
  Oversea: 'Oversea',
  Other: 'Other',
  'Out Working Hour': 'Out Working Hour',
  'Outstanding-Excellent or Accomplished beyond expectations by 50% or more.': 'Outstanding-Excellent or Accomplished beyond expectations by 50% or more.',
  Ordinary: 'Ordinary',
  'Overtime Option': 'Overtime Option',
  'Overtime Request Form': 'Overtime Request Form',
  'Overtime History Record': 'Overtime History Record',
  'Overtime Request Detail': 'Overtime Request Detail',
  'Overtime Type': 'Overtime Type',
  'Office Phone Number': 'Office Phone Number',
  'Overall Rating Results': 'Overall Rating Results',
  Open: 'Open',
  'Outstanding/Excellence': 'Outstanding/Excellence',
  Outstanding: 'Outstanding',
  'Onboarding Tasks': 'Onboarding Tasks',
  'Office Phone No': 'Office Phone No',
  Online: 'Online',
  'Other remarks(if any)': 'Other remarks(if any)',

  // P

  'Please select the school': 'Please select the school',
  'Part Time': 'Part Time',
  'Print Option': 'Print Option',
  'Pending Initial': 'Pending Initial',
  'Please complete the Engagement Survey Form.': 'Please complete the Engagement Survey Form.',
  Permitted: 'Permitted',
  'Phone Number': 'Phone Number',
  PIP: 'PIP',
  'Phd Degree': 'Phd Degree',
  'Position Changed': 'Position Changed',
  Promotion: 'Promotion',
  Promoted: 'Promoted',
  'Probation Status': 'Probation Status',
  'Previous Permanent Address': 'Previous Permanent Address',
  'Previous Permanent Address in Khmer': 'Previous Permanent Address in Khmer',
  'Previous Phone Number': 'Previous Phone Number',
  'Place of Birth Address in Khmer': 'Place of Birth Address in Khmer',
  'Passport Issued Date': 'Passport Issued Date',
  'Permanent Address in Khmer': 'Permanent Address in Khmer',
  'Place of Birth': 'Place of Birth',
  'Probation Month': 'Probation Month',
  'Payroll Pay Option': 'Payroll Pay Option',
  Page: 'Page',
  'Place Of Course': 'Place Of Course',
  'Present Address': 'Present Address',
  'Payroll Policy Code': 'Payroll Policy Code',
  'Payroll Bank': 'Payroll Bank',
  'Payroll Bank Account No': 'Payroll Bank Account No',
  'Payroll Pay By': 'Payroll Pay By',
  'Personal Phone No': 'Personal Phone No',
  'Personal Email': 'Personal Email',
  'Personal Address': 'Personal Address',
  'Phone No': 'Phone No',
  'Personal Information Change Request Form': 'Personal Info. Change Request Form',
  'Personal Information': 'Personal Information',
  Performance: 'Performance',
  Payroll: 'Payroll',
  'Payroll History Record': 'Payroll History Record',
  'Passport No': 'Passport No',
  'Permanent Address': 'Permanent Address',
  'Permanent District': 'Permanent District',
  'Permanent Province': 'Permanent Province',
  'Post Code': 'Post Code',
  Province: 'Province',
  'Probation Date': 'Probation Date',
  Probation: 'Probation',
  Profile: 'Profile',
  'Position Code': 'Position Code',
  Position: 'Position',
  'Posting Date': 'Posting Date',
  'Pay In Step': 'Pay In Step',
  'Pay In Month': 'Pay In Month',
  'Pay In Year': 'Pay In Year',
  'Payroll Detail': 'Payroll Detail',
  'Pension Fund 2% Pay': 'Pension Fund 2% Pay',
  'Payroll Calculation Details': 'Payroll Calculation Details',
  'Pending Approval': 'Pending Approval',
  'Pending Check': 'Pending Check',
  Print: 'Print',
  'Partially meet less than': 'Partially meet less than',
  'Partially meet around': 'Partially meet around',
  'Partially meet more than': 'Partially meet more than',
  'Partially Meets': 'Partially Meets',
  'Please help of evaluated the effectiveness of this training. The training is divided into 4 parts.':
    'Please help of evaluated the effectiveness of this training. The training is divided into 4 parts.',
  'Please Rating The Quality Of The Training From 1-4': 'Please Rating The Quality Of The Training From 1-4',
  'Public Holiday': 'Public Holiday',
  'Penalty Leave': 'Penalty Leave',
  'Paternity Leave': 'Paternity Leave',
  'Personal Management': 'Personal Management',
  Processing: 'Processing',
  Pending: 'Pending',
  'Pending Task/Projects (Any Pending Tasks or under Progress during the Handover':
    'Pending Task/Projects (Any Pending Tasks or under Progress during the Handover',
  'Personal Info. Change Request Form': 'Personal Info. Change Request Form',
  Personal: 'Personal',
  'Personal Info. Change Request': 'Personal Info. Change Request',
  'Personal Information Of The Complainant': 'Personal Information Of The Complainant',
  'Progress (%)': 'Progress (%)',
  'PVF Pay': 'PVF Pay',
  'Pay In Month & Year': 'Pay In Month & Year',
  'Payslip Password': 'Payslip Password',
  'Prolong illness Leave': 'Prolong illness Leave',
  Period: 'Period',
  'Please provide your suggestion(s) to enable the Company to improve both working condition and business':
    'Please provide your suggestion(s) to enable the Company to improve both working condition and business',
  'Personal Information Of Survey': 'Personal Information Of Survey',
  'Pending Review': 'Pending Review',
  'Pending Verify': 'Pending Verify',
  'Physical + Online': 'Physical + Online',
  'Physical Classroom': 'Physical Classroom',
  Physical: 'Physical',

  // Q
  Questionnaire: 'Questionnaire',

  // R

  Resubmit: 'Resubmit',
  Resignation: 'Resignation',
  Reference: 'Reference',
  'Request For': 'Request For',
  'Reference for Khmer': 'Reference for Khmer',
  'Document Receive Date': 'Document Receive Date',
  'Register Now': 'Register Now',
  'Registration Date': 'Registration Date',
  Relationship: 'Relationship',
  'Residential Status': 'Residential Status',
  Request: 'Request',
  Room: 'Room',
  Return: 'Return',
  'Reset all': 'Reset all',
  'Swap Card': 'Swap Card',
  'Resignation Notice Date': 'Resignation Notice Date',
  'Resignation/Terminated Date': 'Resignation/Terminated Date',
  Resident: 'Resident',
  Returned: 'Returned',
  Remark: 'Remark',
  'Reason Of Leave Request': 'Reason Of Leave Request',
  'Resignation Request Form': 'Resignation Request Form',
  'Resignation Request': 'Resignation Request',
  Recruitment: 'Recruitment',
  'Request Change to Update Timesheets': 'Request Change to Update Timesheets',
  'Request Change': 'Request Change',
  'Requested By': 'Requested By',
  Requester: 'Requester',
  'Request Change Personal Information': 'Request Change Personal Information',
  'Request Change Contact & Emergency Contact': 'Request Change Contact & Emergency Contact',
  'Request Change Birth Address Information': 'Request Change Birth Address Information',
  'Request Change Permanent Address Information': 'Request Change Permanent Address Information',
  'Request Change Current Address Information': 'Request Change Current Address Information',
  'Reason Of Overtime Request': 'Reason Of Overtime Request',
  'Review Date': 'Review Date',
  Rejected: 'Rejected',
  'Reason Of Change DayOff': 'Reason Of Change DayOff',
  Records: 'Records',
  Record: 'Record',
  Resilience: 'Resilience',
  Regular: 'Regular',
  'Request For No Of Scholarship': 'Request For No Of Scholarship',
  'Request For Name': 'Request For Name',
  'Request For Gender': 'Request For Gender',
  'Request For Relationship': 'Request For Relationship',
  'Resignation Form Request': 'Resignation Request',
  Released: 'Released',
  'Request Details': 'Request Details',
  'Reason Of Request': 'Reason Of Request',
  'Request Date': 'Request Date',
  Reject: 'Reject',
  'Request Of Complaint Details': 'Request Of Complaint Details',
  'Reasons for leaving': 'Reasons for leaving',
  'Reason Of Resignation': 'Reason Of Resignation',
  Reviewed: 'Reviewed',
  'Reason of Termination': 'Reason of Termination',
  'Resignation Detail': 'Resignation Detail',
  'Resignation Date': 'Resignation Date',
  'Remaning of day': 'Remaning of day',
  'Require Register': 'Require Register',
  'Review By': 'Review By',
  'Reason of Overtime Request': 'Reason of Overtime Request',
  'Registration Status': 'Registration Status',

  // S

  'Scholarship Child Order': 'Scholarship Child Order',
  'Spouse or Child’s Gender': 'Spouse or Child’s Gender',
  'Spouse or Child’s Name': 'Spouse or Child’s Name',
  'Subject Option': 'Subject Option',
  'Suspend Leave (Personal reason)': 'Suspend Leave (Personal reason)',
  'Shift Group': 'Shift Group',
  'Standby Location': 'Standby Location',
  'Standby Building Code': 'Standby Building Code',
  'Staff Leaving': 'Staff Leaving',
  'Successful Probation': 'Successful Probation',
  'See more': 'See more',
  'Salary Adjustment': 'Salary Adjustment',
  Sessions: 'Sessions',
  Spouse: 'Spouse',
  Separated: 'Separated',
  Single: 'Single',
  Remarried: 'Remarried',
  Divorced: 'Divorced',
  Widowed: 'Widowed',
  'Scoring of Survey and Tardiness or Attendance Score': 'Scoring of Survey and Tardiness or Attendance Score',
  'Scoring of Survey and Attendance': 'Scoring of Survey and Attendance',
  'Survey Result (Score)': 'Survey Result (Score)',
  'Sick Leave Entitlement Balance': 'Sick Leave Entitlement Balance',
  'Suspended Start Date': 'Suspended Start Date',
  'Suspended Start Date/Terminate Effective Date': 'Suspended Start Date/Terminate Effective Date',
  'Suspend Leave': 'Suspended Leave Request',
  'Suspended Leave Request': 'Suspended Leave Request',
  'Suspend Duration (If any)': 'Suspend Duration (If any)',
  'Sub Unit': 'Sub Unit',
  'Shift Code': 'Shift Code',
  'Swipe Card Machine Code': 'Swipe Card Machine Code',
  'Send Notify To Successor': 'Send Notify To Successor',
  'Send Notify To Delegator': 'Send Notify To Delegator',
  'Send Notify To Line Manager': 'Send Notify To Line Manager',
  Subject: 'Subject',
  'Successor Status': 'Successor Status',
  'School Fee In Total': 'School Fee In Total',
  'School Fee In Semester': 'School Fee In Semester',
  'School Fee In Year': 'School Fee In Year',
  'Suspend Duration': 'Suspend Duration',
  'Scholarship Granted': 'Scholarship Granted',
  'Second Priority Remark': 'Second Priority Remark',
  'Second Priority Skills': 'Second Priority Skills',
  'Subspend Leave Request Form': 'Subspend Leave Request Form',
  'Suspension Leave Details': 'Suspension Leave Details',
  'Suspension Leave Option': 'Suspension Leave Option',
  'Sub Employee No': 'Sub Employee No',
  'Sub Name': 'Sub Name',
  'Sub Service Lenght': 'Sub Service Lenght',
  'Service Lenght 1': 'Service Lenght',
  'Sub Gender': 'Sub Gender',
  'Substitution Request Form': 'Substitution Request Form',
  'Sub Career Code': 'Sub Career Code',
  'Snack Break Code': 'Snack Break Code',
  Signature: 'Signature',
  'Start Date': 'Start Date',
  'Start Date ': 'Start Date',
  'Service Length': 'Service Length',
  'Staff Information Record': 'Staff Information Record',
  'Scholarship Request Form': 'Scholarship Request Form',
  'Salary Certificate Request Form': 'Salary Certificate Request Form',
  'Starting Time': 'Starting Time',
  'Starting Date': 'Starting Date',
  'Starting Date 1': 'Starting Date',
  'Religion Code': 'Religion Code',
  'Soft Skills Assessment': 'Soft Skills Assessment',
  Soft: 'Soft',
  'Survey Assessment': 'Survey Assessment',
  Search: 'Search',
  'Self Rating Option': 'Self Rating Option',
  'Skill Description': 'Skill Description',
  'Soft Skill Description': 'Soft Skill Description',
  'Self Score': 'Self Score',
  'Survey Score': 'Survey Score',
  Satisfactory: 'Satisfactory',
  Submit: 'Submit',
  'Strongly Disagree': 'Strongly Disagree',
  'Strongly Agree': 'Strongly Agree',
  'Stategic Thinking': 'Stategic Thinking',
  'Skill Category Code': 'Skill Category Code',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
  'Sick Leave': 'Sick Leave',
  'Special Leave': 'Special Leave',
  'Subspend Leave': 'Subspend Leave',
  'Salary Certificate Request': 'Salary Certificate Request',
  Status: 'Status',
  'Successor No': 'Successor No',
  'Successor ID': 'Successor ID',
  'Staff End Probation in 30 Days': 'Staff End Probation in 30 Days',
  'Software Data (Electronic Files), Password of Systems/Files': 'Software Data (Electronic Files), Password of Systems/Files',
  Send: 'Send',
  Summary: 'Summary',
  'Send Approval': 'Send Approval',
  'Satisfied, Ordinary, Disatified': 'Satisfied, Ordinary, Disatified',
  'Survey Score Result': 'Survey Score Result',
  'Suspended Working': 'Suspended Working',
  'Suspended Working Day': 'Suspended Working Day',
  'Subspended Ending Date': 'Subspended Ending Date',
  'Suspended/Terminate Effective Date': 'Suspended/Terminate Effective Date',
  'Submission Date': 'Submission Date',
  'Submit Date': 'Submit Date',
  'Short Notice Period': 'Short Notice Period',
  'Service Lenght': 'Service Lenght',
  'Step Type': 'Step Type',
  Step: 'Step',
  'Step Option': 'Step Option',
  'Select Workflow Committee': 'Select Workflow Committee',
  'Send To': 'Send To',
  'Suspended Work for investigation': 'Suspended Work for investigation',
  Satisfied: 'Satisfied',

  // T

  'Training Status': 'Training Status',
  'To Issued Date': 'To Issued Date',
  'To ID Card Number': 'To ID Card Number',
  'To Bank Account Number': 'To Bank Account Number',
  'To Phone Number': 'To Phone Number',
  'To Bank Account Name': 'To Bank Account Name',
  'To Account Number': 'To Account Number',
  'To National ID Card': 'To National ID Card',
  'Issue Date': 'Issue Date',
  'To National ID Card Issue Date': 'To National ID Card Issue Date',
  'To Bank Name': 'To Bank Name',
  'To National ID Card Expired Date': 'To National ID Card Expired Date',
  'To Company Phone Number': 'To Company Phone Number',
  Termination: 'Termination',
  'Termination Details': 'Termination Details',
  'Tardiness or Attendance Score': 'Tardiness or Attendance Score',
  'Training Information': 'Training Information',
  'Team Code': 'Team Code',
  'Training By': 'Training By',
  'Training Calendar Registration': 'Training Calendar Registration',
  'To First Name in Khmer': 'To First Name in Khmer',
  'To Last Name in Khmer': 'To Last Name in Khmer',
  'To Relationship': 'To Relationship',
  'To Contact Number 2': 'To Contact Number 2',
  'To Contact Number': 'To Contact Number',
  'To First Name in Latin': 'To First Name in Latin',
  'To Last Name in Latin': 'To Last Name in Latin',
  'To Permanent Address in Khmer': 'To Permanent Address in Khmer',
  'Training and Development': 'Training and Development',
  'Terminate Effective Date': 'Terminate Effective Date',
  'Type Of The Scholarship': 'Type Of The Scholarship',
  Topic: 'Topic',
  Term: 'Term',
  'Term 1': 'Term',
  'Training Needs Assessment': 'Training Needs Assessment',
  'Third Priority Skills': 'Third Priority Skills',
  'Third Priority Remark': 'Third Priority Remark',
  'Training Sponsor': 'Training Sponsor',
  'Training Sponsor Remark': 'Training Sponsor Remark',
  'Training Location': 'Training Location',
  'Telegram ID': 'Telegram ID',
  To: 'To',
  'To Worksheet Code': 'To Worksheet Code',
  'To Working Date (OFF)': 'To Working Date (OFF)',
  'Tardiness Request Form': 'Tardiness Request Form',
  Training: 'Training',
  'Training Questionnaires': 'Training Questionnaires',
  'To Name': 'To Name',
  'To Gender': 'To Gender',
  'To Marital Status': 'To Marital Status',
  'To Date Of Birth': 'To Date Of Birth',
  'To ID Card No': 'To ID Card No',
  'To Passport No': 'To Passport No',
  'To Emergency Contact Phone No': 'To Emergency Contact Phone No',
  'To Emergency Contact Name': 'To Emergency Contact Name',
  'To Phone No': 'To Phone No',
  'To Email': 'To Email',
  'To Birth Address': 'To Birth Address',
  'To Birth District': 'To Birth District',
  'To Birth Province': 'To Birth Province',
  'To Birth Country Code': 'To Birth Country Code',
  'To Permanent Address': 'To Permanent Address',
  'To Permanent District': 'To Permanent District',
  'To Permanent Province': 'To Permanent Province',
  'To Post Code': 'To Post Code',
  'To Address': 'To Address',
  'To District': 'To District',
  'To Province': 'To Province',
  Teamwork: 'Teamwork',
  Time: 'Time',
  'Tax Pay': 'Tax Pay',
  'Training Topic Test Assessment Test': 'Training Topic Test Assessment Test',
  'Training History': 'Training History',
  'Training Fees': 'Training Fees',
  'Training Leave': 'Training Leave',
  Type: 'Type',
  'Training Topic Assessment Test': 'Training Topic Assessment Test',
  'Training & Department': 'Training & Department',
  'Training History Record': 'Training History Record',
  'Task Description': 'Task Description',
  'Task Group': 'Task Group',
  'To Successor': 'To Successor',
  'To Main Successor': 'To Main Successor',
  'Training & Development': 'Training & Development',
  Title: 'Title',
  'Title of the Incident': 'Title of the Incident',
  'To Time': 'To Time',
  'THIS MONTH': 'THIS MONTH',
  'Total Completed': 'Total Completed',
  'Total Processing': 'Total Processing',
  'Total Pending': 'Total Pending',
  Total: 'Total',
  Terminated: 'Terminated',
  'Termination Request Form': 'Termination Request',
  'Termination Request': 'Termination Request',
  'Terminiation Type': 'Terminiation Type',
  'Training Calendar': 'Training Calendar',
  'Training Channel': 'Training Channel',
  'Training venue': 'Training venue',
  'Training Duration Remark': 'Training Duration Remark',
  'Training Employee Name': 'Training Employee Name',
  'Traget Audience': 'Traget Audience',
  'Training Employee No': 'Training Employee No',
  'Training Topic': 'Training Topic',
  'Training Fee Remark': 'Training Fee Remark',
  'Training Option': 'Training Option',
  'Training Type': 'Training Type',
  'Training Program Remark': 'Training Program Remark',
  'Training Program Code': 'Training Program Code',
  'The main objective of the course': 'The main objective of the course',
  "Trainer's ID": "Trainer's ID",
  "Trainer's Name": "Trainer's Name",
  Tuesday: 'Tuesday',
  Thursday: 'Thursday',
  'Tax Base Amount': 'Tax Base Amount',
  'Tax Pay Amount': 'Tax Pay Amount',
  'Tax Base Amount (1st & 2nd)': 'Tax Base Amount (1st & 2nd)',
  'Training Date': 'Training Date',
  'Training Time': 'Training Time',
  'Training Source': 'Training Source',
  'The knowledge that you have already improved before join the course': 'The knowledge that you have already improved before join the course',
  'The knowledge that you have learned and improved after the course': 'The knowledge that you have learned and improved after the course',
  'The knowledge that you will be able to use or implement in the company': 'The knowledge that you will be able to use or implement in the company',
  'Total Hours': 'Total Hours',

  // U

  Unavailable: 'Unavailable',
  Unchecked: 'Unchecked',
  Unit: 'Unit',
  'University / Institute Name': 'University / Institute Name',
  undefined: 'undefined',
  Unacceptable: 'Unacceptable',
  Unsatisfactory: 'Unsatisfactory',
  'Unpaid Leave (Ex: No class...)': 'Unpaid Leave (Ex: No class...)',
  'Unpaid Leave': 'Unpaid Leave',
  'Upload Files': 'Upload Files',
  'Update Activity Status': 'Update Activity Status',
  'Usage of day': 'Usage of day',
  'User ID': 'User ID',
  Username: 'Username',

  // V
  'Visa Expiry Remark': 'Visa Expiry Remark',
  'Verbal Warning': 'Verbal Warning',
  Verified: 'Verified',
  'Verify By': 'Verify By',

  // W

  'Waiver after AL deduction': 'Waiver after AL deduction',
  Waive: 'Waive',
  'We Value Your Feedback': 'We Value Your Feedback',
  'Working Hour Changed': 'Working Hour Changed',
  'Weightage % (Survey)': 'Weightage % (Survey)',
  'What challenges in term of skills and capacity are you facing in carrying out your work and responsibilities?':
    'What challenges in term of skills and capacity are you facing in carrying out your work and responsibilities?',
  'What training courses needed to improve your capacity and support your role and responsibilities more effectively? Please list down 3 priority training courses?':
    'What training courses needed to improve your capacity and support your role and responsibilities more effectively? Please list down 3 priority training courses?',
  'Working Date': 'Working Date',
  'Working Date (OFF)': 'Working Date (OFF)',
  'Working Condition Type': 'Working Condition Type',
  'Worksheet Code': 'Worksheet Code',
  'Weekend Day': 'Weekend Day',
  Weekend: 'Weekend',
  Weekday: 'Weekday',
  'Weightage % (Other)': 'Weightage % (Other)',
  'Weightage % (KPI)': 'Weightage % (KPI)',
  Weight: 'Weight',
  'Weight (%)': 'Weight (%)',
  'Work Book Expiry Remark': 'Work Book Expiry Remark',
  'Work Permit Book Expiry Remark': 'Work Permit Book Expiry Remark',
  Working: 'Working',
  'What would have made you keep staying with the Company?': 'What would have made you keep staying with the Company?',
  'What changes would you suggest?': 'What changes would you suggest?',
  'Weightage (Attendance)': 'Weightage (Attendance)',
  'Written Warning': 'Written Warning',
  'Working Day': 'Working Day',
  'Workflow Committee': 'Workflow Committee',
  'Workflow Committees': 'Workflow Committees',
  'Written Warning with Suspended Working': 'Written Warning with Suspended Working',
  Wednesday: 'Wednesday',

  // X

  // Y

  'Your Comments on Salary & Benefits with the Company': 'Your Comments on Salary & Benefits with the Company',
  'Your Comments on Working Conditions & Culture': 'Your Comments on Working Conditions & Culture',
  'Your Comments about Your Line Manager/Head of Department': 'Your Comments about Your Line Manager/Head of Department',
  'Your Other and Feedbacks': 'Your Other and Feedbacks',
  'Your Personal Contact information After Leaving': 'Your Personal Contact information After Leaving',
  'Your Expected Results after the training': 'Your Expected Results after the training',
  'Yes, delete!': 'Yes, delete!',
  Yes: 'Yes',
  Year: 'Year',

  // Z

  // Number

  0: '0',
  1: '1',
  2: '2',
  3: '3',
  4: '4',
  5: '5',
};
export default enMessages;
